import {
    Flex,
    Text,
    Image
} from '@chakra-ui/react';
import {
    StarIcon,
} from '@chakra-ui/icons';

const Comment = ({ comment }) => {
    return (
        <Flex
            bg={'#fefefe'}
            flexDirection={{
                base: 'row',
                md: 'column',
            }}
            borderRadius={'lg'}
            w='100%'
            flex={1}
            zIndex={1}
            position={'relative'}
            shadow={'md'}
            cursor={'pointer'}
            p={5}
        >
            <Flex flex={1}>
                <Flex w='100%' flexDir='column' justifyContent='space-between'>
                    <Flex alignItems={'center'}>  
                        <Image
                            src={'https://upload.wikimedia.org/wikipedia/commons/1/18/Mark_Zuckerberg_F8_2019_Keynote_%2832830578717%29_%28cropped%29.jpg'}
                            alt={'Mark Zuckerberg'}
                            w={10}
                            h={10}
                            borderRadius={'full'}
                            objectFit={'cover'}
                            mr={2}
                        />
                        <Flex flexDir='column' h='100%' alignItems='flex-start'>
                            <Text fontSize='sm' color='gray.500' >
                                {comment.name}
                            </Text>
                            <Flex>
                                {[...Array(comment.rating)].map((e, i) => (
                                    <StarIcon key={i} color='yellow.500' boxSize={3} />
                                ))}
                            </Flex>
                        </Flex>
                    </Flex>
                    <Text mt={2} fontSize='sm' color='gray.500' >
                        {comment.comment}
                    </Text>
                </Flex>
            </Flex>
        </Flex>
    )
}

export default Comment;